import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Garden & Greenhouse - Expert Gardening Tips Since 1998',
  description = 'Your trusted source for gardening advice, premium products, and AI-powered plant care. Discover expert tips, affiliate recommendations, and comprehensive growing guides.',
  keywords = 'gardening tips, garden advice, greenhouse, plant care, organic gardening, seeds, garden tools, landscaping, pest control, indoor gardening',
  image = 'https://customer-assets.emergentagent.com/job_grow-master-5/artifacts/264bpae4_GardenAndGreenhouseLogo.jpg',
  url = 'https://www.gardenandgreenhouse.com',
  type = 'website',
  article = null
}) => {
  const siteName = 'Garden & Greenhouse';
  const twitterHandle = '@GardenGreenhouse';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta property="twitter:site" content={twitterHandle} />
      <meta property="twitter:creator" content={twitterHandle} />
      
      {/* Article Specific */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedTime} />
          <meta property="article:modified_time" content={article.modifiedTime} />
          <meta property="article:author" content={article.author} />
          <meta property="article:section" content={article.section} />
          {article.tags && article.tags.map(tag => (
            <meta key={tag} property="article:tag" content={tag} />
          ))}
        </>
      )}
    </Helmet>
  );
};

export default SEO;
